export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пароль"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скасувати"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Продовжити"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть пароль підтвердження"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пароль підтвердження"])}
}